// Lib
import { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { getUserCandidates } from 'modules/Candidates/actions';
import { getNotes } from 'actions/notes';
import { clearJobBoard } from '../actions';

// Selectors
import { getCandidatesWithStages } from '../selectors';

const useJobBoardCandidates = (jobPostId: number) => {
  const dispatch = useDispatch();
  const { stages, loading } = useSelector(getCandidatesWithStages);

  const getUserCandidatesHandler = useCallback(() => dispatch(getUserCandidates(jobPostId)), [
    dispatch,
    jobPostId,
  ]);

  const clearJobBoardHandler = useCallback(() => dispatch(clearJobBoard()), [dispatch]);

  const isContainCandidates = useMemo(
    () => !!stages.map((stage: any) => stage.candidates).filter((arr: any) => arr.length).length,
    [stages]
  );

  const getCandidatesNotesHandler = useCallback(() => dispatch(getNotes()), [dispatch]);

  useEffect(() => {
    getUserCandidatesHandler();
    getCandidatesNotesHandler();
    return () => {
      clearJobBoardHandler();
    };
  }, [getUserCandidatesHandler, clearJobBoardHandler, getCandidatesNotesHandler]);

  return { stages, loading, isContainCandidates };
};

export default useJobBoardCandidates;
